/**
 * 🚨 Domain-Specific Errors
 *
 * Custom error classes للـ business logic.
 * كل error يحمل code للـ i18n + context للـ debugging.
 */

export abstract class DomainError extends Error {
  abstract readonly code: string;
  readonly context: Readonly<Record<string, unknown>>;

  constructor(message: string, context: Record<string, unknown> = {}) {
    super(message);
    this.name = this.constructor.name;
    this.context = Object.freeze({ ...context });
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

// ─── Validation ───
export class ValidationError extends DomainError {
  readonly code = 'VALIDATION_ERROR';
}

// ─── Booking ───
export class BookingConflictError extends DomainError {
  readonly code = 'BOOKING_CONFLICT';
}

export class VenueUnavailableError extends DomainError {
  readonly code = 'VENUE_UNAVAILABLE';
}

export class InsufficientDepositError extends DomainError {
  readonly code = 'INSUFFICIENT_DEPOSIT';
}

// ─── Vendor ───
export class VendorNotApprovedError extends DomainError {
  readonly code = 'VENDOR_NOT_APPROVED';
}

export class VendorSuspendedError extends DomainError {
  readonly code = 'VENDOR_SUSPENDED';
}

// ─── Auth ───
export class UnauthorizedError extends DomainError {
  readonly code = 'UNAUTHORIZED';
}

export class ForbiddenError extends DomainError {
  readonly code = 'FORBIDDEN';
}

// ─── Resource ───
export class NotFoundError extends DomainError {
  readonly code = 'NOT_FOUND';
}

// ─── Conflict (concurrent updates / double-booking) ───
export class ConflictError extends DomainError {
  readonly code = 'CONFLICT';
}

// ─── Business Rule Violation ───
export class BusinessRuleViolationError extends DomainError {
  readonly code = 'BUSINESS_RULE_VIOLATION';
}
